import { EnvironmentOutlined } from '@ant-design/icons';
import { Comune, Provincia } from '@framework/api-client';
import {
  IWidgetType,
  RequiredRule,
  WidgetCategory,
  WidgetMainType,
  tran,
} from '@framework/engine';
import { get } from 'lodash';
import React from 'react';
import { IProvinceWidget, WidgetProvinceType } from './IProvinceWidget';
import { ProvinceWidgetComponent } from './ProvinceWidgetComponent';
import { ProvinceWidgetConfigComponent } from './ProvinceWidgetConfigComponent';
import { ProvinceWidgetConfigSchema } from './ProvinceWidgetConfigSchema';
import { ProvinceWidgetSelectComponent } from './components/ProvinceWidgetSelectComponent';
import {
  createProvinceWidgetSchema,
  getProvinceDataFieldName,
  getTownDataFieldName,
} from './createProvinceWidgetSchema';
import { getProvinceWidgetReference } from './getProvinceWidgetReference';
import { getProvinceWidgetSiblingReferences } from './getProvinceWidgetSiblingReferences';

declare module '@framework/engine/src/schema/widgets/Widget' {
  export enum WidgetType {
    Province = 'province',
  }
}

/**
 * Struttura del widget di download
 */
export const ProvinceWidgetType: IWidgetType<IProvinceWidget> = {
  type: WidgetProvinceType,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  name: 'Città e Provincia',
  icon: <EnvironmentOutlined />,
  hasValue: true,
  getReference: getProvinceWidgetReference,
  getSiblingReferences: getProvinceWidgetSiblingReferences,
  formComponent: ProvinceWidgetComponent,
  previewComponent: ProvinceWidgetSelectComponent,
  configValidator: ProvinceWidgetConfigSchema,
  configComponent: ProvinceWidgetConfigComponent,
  configOptions: {
    removeCollapsePanel: true,
  },
  createFormSchema: createProvinceWidgetSchema,
  // Traduzioni
  translationSchema: tran.widget({
    label: tran.rte(),
    provinceLabel: tran.rte(),
    townLabel: tran.rte(),
    provincePlaceholder: tran.string(),
    townPlaceholder: tran.string(),
    provinceHelpText: tran.rte(),
    townHelpText: tran.rte(),
  }),
  rules: [RequiredRule],
  hydrate: ({ context, path, widget }) => {
    try {
      // Recupero i dati della provincia
      const provinceDataFieldName = getProvinceDataFieldName(path);
      const provinceData = get(context.values, provinceDataFieldName) as
        | Provincia
        | undefined;
      const provinceLabelValue = provinceData?.nome;

      // Recupero i dati del comune
      const townDataFieldName = getTownDataFieldName(path);
      const townData = get(context.values, townDataFieldName) as
        | Comune
        | undefined;
      const townLabelValue = townData?.nome;

      // Li ritorno, il campo andrà a sovrascrivere il valore ritornato.
      return {
        value: {
          province: provinceLabelValue,
          town: townLabelValue,
        },
      };
    } catch {
      console.error(`[ProvinceWidget] Errore durante l'hydrate del widget ${path}`, { context, path, widget }); // prettier-ignore
      return {
        value: {
          province: 'N/A',
          town: 'N/A',
        },
      };
    }
  },
};
